import React from 'react';
import { getDefaultCityList } from '../../common/commonFunction';
import {
    AhmedabadSvg,
    BengaluruSvg,
    ChandigarhSvg,
    DelhiSvg,
    GoaSvg,
    HyderabadSvg,
    JaipurSvg,
    KolkataSvg,
    MumbaiSvg,
    PuneSvg,
    SuratSvg,
    UdaipurSvg,
} from '../../components/svgExports';
const CitySkeleton = () => {
    const renderSvgIcon = (name) => {
        const svgProps = { colouring: 'group-hover:fill-[#CB2129]' };
        const icons = {
            Ahmedabad: <AhmedabadSvg {...svgProps} />,
            Surat: <SuratSvg {...svgProps} />,
            Delhi: <DelhiSvg {...svgProps} />,
            Chandigarh: <ChandigarhSvg {...svgProps} />,
            Udaipur: <UdaipurSvg {...svgProps} />,
            Jaipur: <JaipurSvg {...svgProps} />,
            Mumbai: <MumbaiSvg {...svgProps} />,
            Pune: <PuneSvg {...svgProps} />,
            Bengaluru: <BengaluruSvg {...svgProps} />,
            Goa: <GoaSvg {...svgProps} />,
            Hyderabad: <HyderabadSvg {...svgProps} />,
            Kolkata: <KolkataSvg {...svgProps} />,
        };
        return icons[name] || null;
    };

    const defaultCityList = getDefaultCityList();
    return (
        defaultCityList.map((defaultCity, indexDefaultCity) => (
            <div
                key={defaultCity.name + indexDefaultCity}
                className="text-center cursor-pointer hover-container group"
            >
                <div className="w-[72px] h-[72px] m-auto flex flex-col justify-end items-center">
                    {renderSvgIcon(defaultCity.name)}
                </div>
                <p className="text-[#101010] text-sm md:text-base font-medium capitalize break-all mt-[3px] group-hover:text-red-500">
                    {defaultCity.name}
                </p>
            </div>
        ))
    );
};

export default CitySkeleton;